import React from 'react';
import { CircularProgress, Badge, Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { toggleSspModels, OrderPayload } from 'pages/myidm/store';
import { commonStyles as style } from 'assets/style';
import PropTypes from 'prop-types';
import Btn from 'components/button';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { validateGroupName } from 'pages/myidm/utils/validation';

function SelectMemberBtn({ index }) {
    const [isLoading, setLoading] = React.useState(false);
    const [modal, setModal] = useRecoilState(toggleSspModels);
    const [order] = useRecoilState(OrderPayload);

    const handleOpenMemlistModal = () => {
        setLoading(true);
        setModal({
            ...modal,
            isMemberlist: true,
            index,
        });
        setLoading(false);
    };

    // Check if the resource group has required fields filled
    const resourceGroup = order?.multipleResourceGroups?.[index];
    const prefix = `${resourceGroup?.groupCategory || ''}.${resourceGroup?.groupSubCategoryDetails?.backendName || ''}.`;
    const isGroupNameValid = validateGroupName(resourceGroup?.groupName, prefix, order?.multipleResourceGroups, index).isValid;

    const isValid =
        resourceGroup?.groupCategory &&
        resourceGroup?.groupSubCategory &&
        resourceGroup?.activeDirectoryGroupType &&
        resourceGroup?.domainType &&
        resourceGroup?.groupOwner &&
        resourceGroup?.groupName &&
        isGroupNameValid;
    return (
        <Box sx={ProvisioningStyles.dataDisk.btnWrapper}>
            <Badge
                sx={{ ...ProvisioningStyles.dataDisk.badgeWidth, width: 'auto' }}
                overlap="circular"
                color="error"
                variant={!resourceGroup?.members?.length ? 'dot' : 'standard'}
            >
                <Btn
                    data-testid={`select-mem-btn-${index}`}
                    variant="contained"
                    disabled={isLoading || !isValid}
                    sx={{ ...style.primaryMediumButton, width: '166px' }}
                    onClick={handleOpenMemlistModal}
                >
                    {isLoading ? <CircularProgress color="inherit" size={16} /> : 'Select Member'}
                </Btn>
            </Badge>
        </Box>
    );
}

SelectMemberBtn.propTypes = {
    index: PropTypes.number.isRequired,
};

export default SelectMemberBtn;
